import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AddPhotoImageData } from "common/types";
import User from "../../../types/user";
import { flagVenuePhotoDesktop, flagVenuePhotoMobile } from "../../../apis";

export function useFlagPhoto() {
  const queryClient = useQueryClient();
  const { mutate, error, status, data } = useMutation({
    mutationFn: ({
      photoReviewId,
      accessToken,
      notes,
      images,
      isMobile,
    }: {
      photoReviewId: string;
      accessToken: string;
      notes: string;
      images: AddPhotoImageData[];
      isMobile?: boolean;
    }) => {
      if (isMobile) {
        return flagVenuePhotoMobile(
          photoReviewId,
          accessToken,
          notes,
          images
        );
      } else {
        return flagVenuePhotoDesktop(
          photoReviewId,
          accessToken,
          notes,
          images
        );
      }
    },
    onSuccess: () => {},
  });
  return { mutate, error, isPending: status === "pending", data };
}
